export const propRules = {
  rules: {
    heading: "Accommodation rules",
    subheading:
      "Set the check-in and check-out times that will be shared with the guest during check-in.",
    cloneTitleNoun: "schedules",
    cloneItemNoun: "the schedules",
    bulkNoticePrefix:
      "This change will apply to the {count} accommodations linked to",
    checkinLabel: "Check-in",
    checkoutLabel: "Check-out",
    defaultCheckin: "Default 15:00",
    defaultCheckout: "Default 12:00",
    saving: "Saving…",
    save: "Save",
    toasts: {
      loadError: "Could not load the listing data.",
      bulkApplied: "Rules applied to {count} accommodations",
      saveSuccess: "Rules saved successfully",
      bulkPartialError: "Some accommodations could not be updated",
      saveError: "Error saving the rules",
    },
  },
  services: {
    cloneTitleNoun: "equipment and amenities",
    cloneItemNoun: "the equipment and amenities",
    toasts: {
      saveSuccess: "Amenities saved successfully",
      saveError: "Error saving the amenities",
    },
  },
  maintenance: {
    title: "Accommodation maintenance",
    scopeProperty: "Entire accommodation",
    scopeUnits: "Specific units",
    selectUnits: "Select units",
    dateFrom: "From",
    dateTo: "To",
    closeArrivals: "Close arrivals (CTA)",
    closeDepartures: "Close departures (CTD)",
    applying: "Applying...",
    apply: "Apply maintenance",
    removing: "Removing...",
    remove: "Remove maintenance",
    toasts: {
      rangeScopeRequired:
        "Complete the date range and scope (units or accommodation).",
      applied: "Maintenance applied.",
      applyError: "Error applying maintenance.",
      removed: "Maintenance removed.",
      removeError: "Error removing maintenance.",
    },
  },
  propMaintenance: {
    title: "Accommodation maintenance",
    scopeProperty: "Entire accommodation",
    scopeUnits: "Specific units",
    selectUnits: "Select units",
    dateFrom: "From",
    dateTo: "To",
    closeArrivals: "Close arrivals (CTA)",
    closeDepartures: "Close departures (CTD)",
    applying: "Applying...",
    apply: "Apply maintenance",
    removing: "Removing...",
    remove: "Remove maintenance",
    toasts: {
      rangeScopeRequired:
        "Complete the date range and scope (units or accommodation).",
      applied: "Maintenance applied.",
      applyError: "Error applying maintenance.",
      removed: "Maintenance removed.",
      removeError: "Error removing maintenance.",
    },
  },
};
